import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";

const state = {
  interviewSchedules: [],
  reviewSchedules: [],
  selectedCampusEvent: null,
};

/**
 * @memberOf module:ScheduleDashboard
 * @namespace store
 * @description central store for schedule dashboard module
 */
export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};
